<template>
  <div>
    <v-select
      v-if="hasMultipleBranches"
      @change="handleBranchSelect"
      item-text="name"
      item-value="id"
      :items="branches"
      :value="value"
      :label="label"
      :rules="rules"
      return-object
      outlined
    />

    <input
      v-model="uniqueBranch"
      v-if="!hasMultipleBranches"
      @input="handleBranchSelect"
      type="hidden"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BranchSelect',

  props: {
    value: {
      type: String,
      default: '',
    },

    label: {
      type: String,
    },

    rules: {
      type: Array,
    },

    branches: {
      type: Array,
      required: true,
    },

    hasMultipleBranches: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters(['appointmentFields']),

    isServiceProviderUser() {
      const userRole = localStorage.getItem('access_roles')
      return userRole.includes('ROLE_SERVICE_PROVIDER')
    },
  },

  data() {
    return {
      isLoading: true,
      uniqueBranch: null,
    }
  },

  methods: {
    ...mapActions(['fetchBranches']),
    ...mapMutations([
      'setAppointmentFields',
      'setAppointmentCreationConfirmToClose',
    ]),

    handleBranchSelect(branch) {
      this.setAppointmentCreationConfirmToClose(true)
      this.setAppointmentFields({ real_estate_branch_id: branch?.id })
      this.setAppointmentFields({ real_estate_branch_name: branch?.name })
    },

    initBranches() {
      const realEstateId = this.appointmentFields.real_estate_id
      this.fetchBranches(realEstateId)
        .then(() => {
          const branchId = localStorage.getItem('users_branch_id')
          const branchName = localStorage.getItem('users_branch_name')

          if (
            branchId &&
            branchId != 'undefined' &&
            branchName &&
            branchName != 'undefined'
          ) {
            this.setAppointmentFields({ real_estate_branch_id: branchId })
            this.setAppointmentFields({ real_estate_branch_name: branchName })
          }
        })
        .then(() => {
          !this.hasMultipleBranches &&
            this.branches[0] &&
            this.setAppointmentFields({
              real_estate_branch_id: this.branches[0]?.id,
              real_estate_branch_name: this.branches[0]?.name,
            })
        })
        .finally(() => {
          this.isLoading = false

          if (!this.hasMultipleBranches) {
            this.setUniqueBranch()
          }
        })
    },

    setUniqueBranch() {
      this.uniqueBranch = this.branches[0]?.id
    },
  },

  mounted() {
    this.initBranches()
  },
}
</script>
